









































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import FormError from '@/components/common/forms/FormError.vue';
import UserSelect from '@/components/common/selects/UserSelect.vue';
import TagSelect from '@/components/common/selects/TagSelect.vue';
import {
  ICustomerAutocompleteOption,
  ITag,
  ITask,
  TagCategory,
  TaskModel,
  TaskPriority,
  TaskPriorityLabels,
  TaskStatus,
} from 'admiral-core';
import { CustomerApi } from '@/services/CustomerApi';
import FormTextarea from '@/components/common/forms/FormTextarea.vue';
import { TagApi } from '@/services/TagApi';
import { CalendarIcon, CheckIcon, PlusIcon } from 'vue-feather-icons';
import FormDateInput from '@/components/common/forms/FormDateInput.vue';
import Multiselect from 'vue-multiselect';
import UploadFiles from '@/components/common/UploadFiles.vue';
import CommentBox from '@/components/common/CommentBox.vue';
import Checklist from '@/views/pages/checklists/Checklist.vue';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';

@Component({
  components: {
    Checklist,
    FormDateInput,
    FormTextarea,
    Multiselect,
    TagSelect,
    UserSelect,
    FormError,
    FormInput,
    FormRow,
    PlusIcon,
    UploadFiles,
    CommentBox,
    CheckIcon,
    CalendarIcon,
  },
})
export default class TaskForm extends mixins(BaseMixin, PermissionMixin) {
  @Prop({ required: true, type: Object })
  readonly value!: TaskModel;

  @Prop({ required: true, type: Object })
  readonly errors!: TaskModel;

  /** When incremented (e.g. create-task modal each open), status Multiselect remounts with current value.status. */
  @Prop({ type: Number, default: 0 })
  readonly statusSelectRemountKey!: number;

  tags: ITag[] = [];
  crmCustomerOptions: ICustomerAutocompleteOption[] = [];

  get useCrmCustomers(): boolean {
    return this.hasAgencyPermission('customers');
  }

  get customerNameOptions(): string[] {
    return this.crmCustomerOptions.map((option) => option.name);
  }

  get crmCustomerFieldHint(): 'address' | 'new' | null {
    if (!this.useCrmCustomers) {
      return null;
    }
    const input = this.value.customer?.trim();
    if (!input) {
      return null;
    }
    if (this.findCrmCustomerOption(input)) {
      return this.selectedCrmCustomerAddress ? 'address' : null;
    }
    return 'new';
  }

  get selectedCrmCustomerAddress(): { street?: string; cityLine?: string } | null {
    const input = this.value.customer?.trim();
    if (!input) {
      return null;
    }
    const match = this.findCrmCustomerOption(input);
    if (!match) {
      return null;
    }
    const cityLine = [match.zip, match.city].filter(Boolean).join(' ');
    if (!match.street && !cityLine) {
      return null;
    }
    return {
      street: match.street,
      cityLine: cityLine || undefined,
    };
  }

  findCrmCustomerOption(input: string): ICustomerAutocompleteOption | undefined {
    const normalized = this.normalizeCustomerName(input);
    return this.crmCustomerOptions.find(
      (option) => this.normalizeCustomerName(option.name) === normalized,
    );
  }

  findCrmCustomerOptionById(customerId: string): ICustomerAutocompleteOption | undefined {
    return this.crmCustomerOptions.find((option) => option.id === customerId);
  }

  normalizeCustomerName(name: string): string {
    return name.trim().toLowerCase().replace(/\s+/g, ' ');
  }

  priorityOptions = Object.values(TaskPriority).map((p) => ({
    value: p,
    label: TaskPriorityLabels[p],
  }));

  get priorityOption() {
    const p = this.value.priority ?? TaskPriority.LOW;
    return { value: p, label: TaskPriorityLabels[p] };
  }

  statusOptions = [
    { value: TaskStatus.TODO, label: 'Offen' },
    { value: TaskStatus.IN_PROGRESS, label: 'In Bearbeitung' },
    { value: TaskStatus.IN_WAITING, label: 'Warten' },
    { value: TaskStatus.COMPLETED, label: 'Erledigt' },
    { value: TaskStatus.ARCHIVED, label: 'Archiviert' },
  ];

  readonly calendarExportOptions = [
    { id: 'ics', label: '.ics-Datei' },
    { id: 'google', label: 'Google Kalender' },
    { id: 'apple', label: 'Apple Kalender' },
  ];

  get statusOption() {
    const s = this.value.status ?? TaskStatus.TODO;
    return { value: s, label: this.statusOptions.find((o) => o.value === s)?.label ?? s };
  }

  onStatusChange(opt: { value: TaskStatus }) {
    this.onInput('status', opt.value);
  }

  onPriorityChange(opt: { value: TaskPriority }) {
    this.onInput('priority', opt.value);
  }

  onCalendarExportSelect(option: { id: string }) {
    if (!this.hasDueDateForIcs) return;
    switch (option.id) {
      case 'ics':
        this.exportDueDateToIcs();
        break;
      case 'google':
        this.openGoogleCalendarEvent();
        break;
      case 'apple':
        this.openAppleCalendarEvent();
        break;
      default:
        break;
    }
  }

  async mounted() {
    await Promise.all([this.loadTags(), this.loadCustomers()]);
  }

  /** Lädt CRM-Kunden für das optionale Kundenfeld. */
  async loadCustomers() {
    if (!this.useCrmCustomers) {
      return;
    }
    try {
      const response = await CustomerApi.getDisplayNames({ agency: this.agency });
      this.crmCustomerOptions = response.data || [];
    } catch (e) {
      console.log(e);
    }
  }

  onInput(key: string, value: any) {
    this.$emit('input', { ...this.value, [key]: value });
  }
  onErrorReset(key: string) {
    this.$emit('reset-error', key);
  }

  get TAG_CATEGORY_TASKS() {
    return TagCategory.Tasks;
  }

  updatedTask(task: ITask) {
    // const tasks = [...this.value.tasks];
    // for (let i = 0; i < tasks.length; i++) {
    //   if (this.value.tasks && this.value.tasks[i].id === task.id) {
    //     this.model.tasks[i] = task;
    //   }
    // }
    // this.model.tasks = [...this.model.tasks];
    // this.onInput('tasks', [...this.model.tasks]);
  }

  async loadTags() {
    try {
      const response = await TagApi.getTags({
        category: TagCategory.Tasks,
      });
      this.tags = response.data;
    } catch (e) {
      console.log(e);
    }
  }

  createdTask(task: ITask) {
    this.onInput('tasks', [task]);
  }

  escapeIcsText(text: string): string {
    if (!text) return '';
    return String(text)
      .replace(/\\/g, '\\\\')
      .replace(/;/g, '\\;')
      .replace(/,/g, '\\,')
      .replace(/\r?\n/g, '\\n');
  }

  formatIcsUtcStamp(d: Date): string {
    const y = d.getUTCFullYear();
    const m = String(d.getUTCMonth() + 1).padStart(2, '0');
    const day = String(d.getUTCDate()).padStart(2, '0');
    const h = String(d.getUTCHours()).padStart(2, '0');
    const min = String(d.getUTCMinutes()).padStart(2, '0');
    const s = String(d.getUTCSeconds()).padStart(2, '0');
    return `${y}${m}${day}T${h}${min}${s}Z`;
  }

  get hasDueDateForIcs(): boolean {
    const raw = this.value.dueAt;
    if (raw == null) return false;
    const due = new Date(raw);
    return !Number.isNaN(due.getTime());
  }

  getDueDateRangeYmd(): { dateStr: string; endStr: string } | null {
    if (!this.hasDueDateForIcs) return null;
    const due = new Date(this.value.dueAt!);
    const y = due.getFullYear();
    const m = String(due.getMonth() + 1).padStart(2, '0');
    const d = String(due.getDate()).padStart(2, '0');
    const dateStr = `${y}${m}${d}`;
    const endExclusive = new Date(due);
    endExclusive.setDate(endExclusive.getDate() + 1);
    const ey = endExclusive.getFullYear();
    const em = String(endExclusive.getMonth() + 1).padStart(2, '0');
    const ed = String(endExclusive.getDate()).padStart(2, '0');
    const endStr = `${ey}${em}${ed}`;
    return { dateStr, endStr };
  }

  buildIcsContent(): string | null {
    const range = this.getDueDateRangeYmd();
    if (!range) return null;
    const { dateStr, endStr } = range;

    const stamp = this.formatIcsUtcStamp(new Date());
    const uidBase = this.value.id || `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
    const uid = `${uidBase}-${dateStr}@admiral-task`;

    const summary = this.escapeIcsText(this.value.title || 'Aufgabe');
    const desc = this.escapeIcsText(this.value.description || '');

    const lines = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Admiral//Task//DE',
      'CALSCALE:GREGORIAN',
      'BEGIN:VEVENT',
      `UID:${uid}`,
      `DTSTAMP:${stamp}`,
      `DTSTART;VALUE=DATE:${dateStr}`,
      `DTEND;VALUE=DATE:${endStr}`,
      `SUMMARY:${summary}`,
    ];
    if (desc) {
      lines.push(`DESCRIPTION:${desc}`);
    }
    lines.push('END:VEVENT', 'END:VCALENDAR');

    return lines.join('\r\n') + '\r\n';
  }

  toastNoDueDate() {
    (this as any).$toastr?.e?.('Bitte zuerst ein Fälligkeitsdatum wählen.');
  }

  exportDueDateToIcs() {
    const ics = this.buildIcsContent();
    if (!ics) {
      this.toastNoDueDate();
      return;
    }
    const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const safeName = (this.value.title || 'aufgabe').replace(/[/\\?%*:|"<>]/g, '-').slice(0, 80);
    a.download = `${safeName}-faellig.ics`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 500);
  }

  openGoogleCalendarEvent() {
    const range = this.getDueDateRangeYmd();
    if (!range) {
      this.toastNoDueDate();
      return;
    }
    const text = encodeURIComponent(this.value.title || 'Aufgabe');
    const details = encodeURIComponent(this.value.description || '');
    const dates = `${range.dateStr}/${range.endStr}`;
    let url = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${text}&dates=${dates}`;
    if (details) {
      url += `&details=${details}`;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  openAppleCalendarEvent() {
    const ics = this.buildIcsContent();
    if (!ics) {
      this.toastNoDueDate();
      return;
    }
    const dataUrl = `data:text/calendar;charset=utf-8,${encodeURIComponent(ics)}`;
    const win = window.open(dataUrl, '_blank', 'noopener,noreferrer');
    if (!win) {
      this.exportDueDateToIcs();
    }
  }
}
